import React from "react";
import { createPortal } from "react-dom";
import { Loader2, X } from "lucide-react";

const CancelP2PModal = ({ open, onClose, onConfirm, loading = false }) => {
  if (!open) return null;

  return createPortal(
    <div className="p2p-modal-root" role="dialog" aria-modal="true">
      <button type="button" className="p2p-modal-backdrop" aria-label="Close" onClick={onClose} />
      <div className="p2p-modal-sheet p2p-modal-sheet-sm">
        <header className="p2p-modal-head">
          <div>
            <p className="p2p-modal-eyebrow">Cancel wager</p>
            <h2 className="p2p-modal-title">Remove this P2P?</h2>
          </div>
          <button type="button" className="p2p-modal-close" onClick={onClose} aria-label="Close">
            <X size={16} />
          </button>
        </header>

        <p className="p2p-modal-desc">
          Your locked stake will be refunded. This only works before anyone joins or accepts an invite.
        </p>

        <footer className="p2p-modal-foot">
          <button type="button" className="p2p-modal-btn p2p-modal-btn-ghost" onClick={onClose}>
            Keep wager
          </button>
          <button
            type="button"
            className="p2p-modal-btn p2p-modal-btn-danger"
            disabled={loading}
            onClick={onConfirm}
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : "Cancel wager"}
          </button>
        </footer>
      </div>
    </div>,
    document.body
  );
};

export default CancelP2PModal;
